import { AccordionSummary, AccordionSummaryProps, styled } from '@mui/material';
import { ArrowDownIcon } from '@synergy/theme-next';
import { ReactElement } from 'react';

import { PoolAccordionVariant, useAccordionContext } from './pool-accordion';

interface StyledAccordionSummaryProps extends AccordionSummaryProps {
    variant?: PoolAccordionVariant;
}

const StyledAccordionSummary = styled(AccordionSummary, {
    shouldForwardProp: prop => prop !== 'variant',
})<StyledAccordionSummaryProps>(({ theme, variant }) => ({
    ...(variant === 'large' && {
        ...theme.typography.h5,
        paddingTop: theme.spacing(4),
        minHeight: 92, // screendesign
    }),
    ...(variant === 'small' && {
        ...theme.typography.body2,
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        minHeight: 47, // 48px - 1px border from MuiAccordion-root -> box-sizing does not work properly in this case :(
        // expand icon is smaller
        '&>.MuiAccordionSummary-expandIconWrapper>svg': {
            width: 16,
            height: 16,
        },
        '&>.MuiAccordionSummary-content': {
            marginRight: theme.spacing(2),
        },
    }),
}));

export const PoolAccordionSummary = (props: AccordionSummaryProps): ReactElement => {
    const { index, variant } = useAccordionContext();

    return (
        <StyledAccordionSummary
            variant={variant}
            expandIcon={<ArrowDownIcon aria-controls={`panel${index}-content`} />}
            {...props}
        />
    );
};
